import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for D5M3 (託工單核准沖銷)
// ============================================================

export interface ReverseCandidate {
  fd130_01: string;  // 單號
  fd130_11: string;  // 託工日期 (YYYY-MM-DD)
  fd130_12: string;  // 廠商代碼
  fd130_13: string;  // 交貨日期
  fd130_34: string;  // 金額
  fd130_181: string; // 產品代號前段
  fd130_182: string; // 產品代號後段
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const d5m3Api = {
  /** Query subcontract order candidates eligible for reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/d5m3/candidates', { params });
    return res.data;
  },

  /** Execute batch reversal for selected subcontract order records */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/d5m3/reverse', { items });
    return res.data;
  },
};
